<template>
  <div id="app">
    <nav-bar class="navbar"></nav-bar>
    <div class="spacer"></div>
    <router-view />
  </div>
</template>
<script>
import NavBar from './components/NavBar';
export default {
    components: {
        NavBar,
    },
}
</script>
<style>
@import url("https://use.typekit.net/mro0lww.css");
#app {
  font-family: sofia-pro, sans-serif;
  font-weight: 400;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.navbar {
    position: fixed;
    display: block;
    width: 100%;
    z-index: 100;
}
.spacer {
    height: 60px;
}
#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
